<template>
  <div class="meu" v-if="userInfo">
    <div class="flex-center-y p-4">
      <img :src="'/static/images/avatar' + userInfo.avatarUrl" class="avatar" />
      <div class="font-[600] ml-3 text-[var(--page-text)]">
        <p class="text-15 flex-center-y">
          {{ userInfo.nickname }}
          <img src="@a/assets/images/i_edit.png" class="size-6 ml-3" @click="
            showPopup(editApelido, {
              round: true,
              closeable: true,
              closeIcon,
              position: 'bottom',
              class: '!bg-[var(--theme-text-dark)]',
              style: { height: '75%' },
            })
            " />
        </p>

        <p class="text-13 mt-2 flex-center-y font-[400]">
          ID：{{ userInfo.userid }}
          <img src="@a/assets/images/i_copy.png" class="size-6 ml-3" @click="copyText(userInfo.userid)" />
        </p>
      </div>
      <div class="flex-center-y gap-3 ml-auto">
        <span class="bgs-[var(--servico-bg)] size-8" @click="$router.push('/servico')" />
        <span :class="[unreadMessageCount > 0 && 'withRedPoint msg', `bgs-[var(--message-bg)] size-8`]" @click="$router.push('/message')" />
      </div>
    </div>
    
    <slot />

    <div class="px-4 mt-4 rounded-8 overflow-hidden">
      <div class="item" v-for="item in Tabs" :key="item.title" @click="$router.push(item.link)">
        <Icon :name="item.icon" class="text-[var(--theme-primary)]" size="22"/>
        <p class="flex-1 pl-2 text-15 leading-24">{{ item.title }}</p>
        <span v-if="item.count! > 0" class="count">{{ item.count }}</span>
      </div>
    </div>

    <div class="px-4 mt-4 rounded-8 overflow-hidden">
      <div class="item items-center !bg-[var(--bn-bg)] rounded-8" @click="showPopup(QuitPopup, { class: '!bg-transparent text-white' })">
        <img src="@a/assets/images/i_logout.png" alt="" class="size-6" />
        <p class="pl-2 text-15">Sair</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useActivityList, useUserInfo, useWallet } from "@/store";
import { copyText } from "@/utils";
import showPopup from "@a/components/showPopup";
import QuitPopup from "./quit.vue";
import editApelido from "@a/views/Profile/editApelido.vue";

// import i_rasp from "@a/views/Home/images/i_rasp.png";
// import i_meus from "@a/views/Home/images/i_meus.png";
// import i_configure from "@a/views/Home/images/i_configure.png";
// import i_agente from "@a/views/Home/images/i_agente_c.png";
// import i_mensa from "@a/assets/images/i_mensa.png";
import Icon from "@/components/Icon/index.vue";
import closeIcon from "@a/assets/images/i_close.png";
import { getUnreadMessageCount } from "@/api/message.ts";
import type { iTabItem } from '@/types/index'

const activityList = ref(useActivityList().activityList);

const userInfo = computed(() => useUserInfo().userInfo);

useWallet().init()
const unreadMessageCount = ref(0)

getUnreadMessageCount().then((res) => {
  const { code, data } = res;
  if (code == 1) {
    unreadMessageCount.value = data;
  }
});

const agentcenter = computed(() =>
  activityList.value.find((item) => item.linkName === "agentcenter")
);

const Tabs = ref<iTabItem[]>([
  {
    title: "Centro de Agentes",
    icon: 'agente',
    link: `/promocao/agentcenter?activityId=${agentcenter.value?.activityId}`,
  },
  {
    title: "Meus relatórios",
    icon: 'meus',
    link: "/registro",
  },
  {
    title: "Configuração",
    icon: 'configure',
    link: "/profile",
  },
  // {
  //   title: "Raspadinha",
  //   icon: 'rasp',
  //   link: "/ggl",
  //   count: 10,
  // },
  {
    title: "Mensagem",
    icon: 'mensa',
    link: "/message",
    count: unreadMessageCount,
  },
]);
</script>

<style lang="scss" scoped>
.meu {
  @apply pb-10;

  .avatar {
    @apply size-[70px] bg-gradient-to-b from-[#0EBD86] to-[#55A420] rounded-full;
  }

  .msg.withRedPoint {
    &::after {
      right: 0;
      top: 0;
    }
  }

  .item {
    @apply flex-center-x p-[10px_15px] odd:bg-[var(--theme-gray-green15)] even:bg-[var(--theme-gray-green10)] mb-[2px];
  }

  .count {
    @apply bg-[var(--theme-primary)] text-black rounded-full px-[10px] h-[18px] text-center leading-[18px];
  }
}
</style>
